module.exports = __webpack_public_path__ + "assets/img/yd3.fdb7f843.png";